import { create } from "zustand"
import type { TFileModal, TDeleteConfirmModal } from "types/modal.type"

export const useFileModalStore = create<TFileModal>((set) => ({
	isFileModalOpen: false,
	triggerFileModal: () => set((state) => ({ isFileModalOpen: !state.isFileModalOpen })),
	setFileModalClose: () => set(() => ({ isFileModalOpen: false })),
}))

export const useDeleteConfirmModalStore = create<TDeleteConfirmModal>((set) => ({
	isDeleteConfirmModalOpen: false,
	openDeleteConfirmModal: () => set(() => ({ isDeleteConfirmModalOpen: true })),
	setDeleteConfirmModalClose: () => set(() => ({ isDeleteConfirmModalOpen: false })),

	deleteFile: { id: 0, fileName: "" },
	setDeleteFile: (file) => set(() => ({ deleteFile: file })),
}))
